export default __webpack_public_path__ + "static/SR USA - Caramel Color Fat Incorporation Guide-3bd18b8d25646ff0e49eb68aa53fac69.pdf";